import React, { useEffect, useState } from "react";
import DetailedAllRequest from "./DetailedAllRequest";
import SidebarFilterSort from "./SidebarFilterSort";
import { useSelector } from "react-redux";
import config from "../../../../config";

function Received({activeKey}) {
  const user = useSelector((state) => state.user.userInfo);
  const [receiverData, setReceiverData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("allRequest");
  const [selectedSort, setSelectedSort] = useState("mostRelevant");

  const fetchReceiverData = async () => {
    try {
      const response = await fetch(`${config.baseURL}/api/inbox/receiver/${user.id}`);
      const data = await response.json();
      if (data.success) setReceiverData(data.receivers);
    } catch (error) {
      console.error("Failed to fetch receiver data:", error);
    }
  };

  useEffect(() => {
    if (user?.id) {
      fetchReceiverData();
    }
  }, [user, activeKey]);

  const applyFilterAndSort = (data) => {
    let filtered = [...data];

    // Filtering
    if (selectedFilter === "onlineNow") {
      filtered = filtered.filter((item) => item.sender_online);
    } else if (selectedFilter === "withPhotos") {
      filtered = filtered.filter((item) => item.sender_profile_image);
    }

    // Sorting
    if (selectedSort === "newestFirst") {
      filtered.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    } else if (selectedSort === "olderFirst") {
      filtered.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    }
    // "mostRelevant" = default order

    return filtered;
  };

  const filteredReceiverData = applyFilterAndSort(receiverData);

  return (
    <div className="all-request-part">
      <div className="row">
        <div className="col-md-3">
          <SidebarFilterSort
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            selectedSort={selectedSort}
            setSelectedSort={setSelectedSort}
              namespace="received"
          />
        </div>

        <div className="col-md-9">
          <div className="tab-container">
            <DetailedAllRequest
              user={user}
              receiverData={filteredReceiverData}
              fetchReceiverData={fetchReceiverData}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Received;
